import { Component, OnInit } from '@angular/core';
import { Register } from '../../../shared/user.model';
import { NgForm } from '@angular/forms';
import { UserService } from '../../../shared/user.service';
import { Router } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import swal from 'sweetalert2';

@Component({
  selector: 'app-diagnostic-signup',
  templateUrl: './diagnostic-signup.component.html',
  styleUrls: ['./diagnostic-signup.component.css']
})
export class DiagnosticSignupComponent implements OnInit {
  register: any = {};
  formSubmitted: boolean;
  data: any;
  districtlist: any;
  statelist: any;
  title = "User Registration";
  user: any = {};
  date: any;
  Show:any="N";
  p: any = {};
  show1: boolean;
  show2: boolean;
  numericpattern = "^[0-9]*$";
  emailpattern = "^[a-zA-Z0-9._%-+]+@[a-z0-9.-]+\.[a-z]{2,3}$";
   businessTypes: string[] = ['Winter', 'Spring', 'Summer', 'Autumn'];
  category: string[] = ['Ayurveda Products', 'Homeopathic Products', 'Health Suppliments', 'Wellness Products','Medical Equipments','Health Monitors and Devices','Pet Care','Pollution Control','Other'];




    dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  BusinessTypelist: any =[];
  productcatlist: any =[];
 // dt = new Date();
  constructor(private userService: UserService, private errorHandler: ErrorHandler, private router: Router) {
    this.formSubmitted = false;
    this.show1 = false;
    this.show2 = false;
    //this.register = new Register();
  }

  ngOnInit() {
    debugger
  this.GetAll();
 
  }
  showOne() {
    this.show1 = true;
    this.show2 = false;
  }
  showTwo() {
    this.show1 = false;
    this.show2 = true;
  }
GetAll()
{

  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.userService.GetAllBusinessTypeList();
  this.data.subscribe(
    (response: any) => {
      this.BusinessTypelist = response;    
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      document.getElementById('loader-spinner').style.display = "none";
    });

    document.getElementById('loader-spinner').style.display = "block";
  this.data = this.userService.GetAllProductCategoryList();
  this.data.subscribe(
    (response: any) => {
      this.productcatlist = response;    
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      document.getElementById('loader-spinner').style.display = "none";
    });
}


onSubmit(form: NgForm) {
  debugger;
form.value.Service_Brand=this.p.Service_Brand;
  form.value.Password = this.p.PasswordHash;
  form.value.ConfirmPassword = this.p.PasswordHash;
  form.value.Email = this.p.Email;
  form.value.EmailConfirmed = this.p.Email;
  form.value.Address=this.p.Address;
  form.value.FirstName=this.p.FirstName;

  form.value.PhoneNumber=this.p.PhoneNumber;
  form.value.RoleId ='bb429938-44e7-45be-8b98-31b996989705'
  alert("register");
  if (!form.invalid) {
    document.getElementById('loader-spinner').style.display = "block";
    console.log(form.value);
    this.data = this.userService.registerCustomerAcc(form.value);
    this.data.subscribe(
      (response) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('', 'Registered Successfully!', 'success');
        this.router.navigate(['/login']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  } else
    this.formSubmitted = true;
}
 onItemSelect(item: any) {
    console.log(item);
  }
  onSelectAll(items: any) {
    console.log(items);
  }

}



// WEBPACK FOOTER //
// ./src/app/registration/diagnostic-login/diagnostic-signup/diagnostic-signup.component.ts